import { GetAQuoteLabel, GetAQuoteLink, GetAQuoteWrapper } from "./styles";

interface Props{
  cta: {
    id: string;
    internal?: {
      type: string;
    };
    linkUrl?: string;
    linkText?: string;
    buttonUrl?: string;
    buttonLabel?: string;
    buttonType?: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  CtaComponent: React.ComponentType<any>;
  wrapperColor?: string;
  phoneNumberColor?: string;
  inline?: boolean;
}

const GetAQuoteButtonOrLink = ({
  cta,
  CtaComponent,
  wrapperColor,
  phoneNumberColor,
  inline = false,
}: Props) => {
  let buttonLabel;
  let buttonUrl;
  switch (cta?.internal?.type) {
    case 'ContentfulLinkWrapper':
      buttonUrl = cta?.linkUrl;
      buttonLabel = cta?.linkText;
      break;
    case 'ContentfulButton':
      buttonUrl = cta?.buttonUrl;
      buttonLabel = cta?.buttonLabel;
      break;
    default:
      return null;
  }
  // Split the button label by <br> or <br/> or <br />
  const splitLabel = buttonLabel?.split(/<br(\s?\/)?>/i);
  // If <br> is not present, return the old style
  if (!splitLabel || splitLabel.length < 3) {
    return (
      <CtaComponent
        key={cta.id}
        variant={cta?.buttonType}
        href={buttonUrl}
      >
        {buttonLabel}
      </CtaComponent>
    );
  }

  const text = splitLabel[0].trim();
  const phoneNumber = splitLabel[2].trim();

  // Render the new renewal styled button link
  return (
    <GetAQuoteWrapper inline={inline} color={wrapperColor ?? "black"}>
      <GetAQuoteLabel inline={inline}>{text}</GetAQuoteLabel>
      <GetAQuoteLink inline={inline} color={phoneNumberColor ?? "black"} href={`tel:${phoneNumber}`}>{phoneNumber}</GetAQuoteLink>
    </GetAQuoteWrapper>
  );
};

export default GetAQuoteButtonOrLink;
